export default __webpack_public_path__ + "assets/wallet-component.49c19d58.svg";